function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.947 4.75h-.394V3.375C8.553 1.511 6.963 0 5 0 3.038 0 1.447 1.511 1.447 3.375V4.75h-.394C.47 4.75 0 5.198 0 5.75V11c0 .552.471 1 1.053 1h7.894C9.53 12 10 11.552 10 11V5.75c0-.552-.471-1-1.053-1zm-5 3c-.002-.486.364-.903.867-.989.503-.086.999.185 1.175.641a.977.977 0 01-.463 1.21V9.75c0 .276-.235.5-.526.5a.514.514 0 01-.526-.5V8.611a.99.99 0 01-.527-.861zM2.763 3.375C2.763 2.201 3.765 1.25 5 1.25s2.237.951 2.237 2.125V4.5c0 .138-.118.25-.263.25H3.026a.257.257 0 01-.263-.25V3.375z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgSignUpLockSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgSignUpLockSmall;